/**
 * Regla comercial (doc 01 §2): se excluye Chillán Viejo y la Región de Ñuble
 * por conflicto de interés del fundador. Validación BLANDA a propósito — el
 * propio doc lo dice explícito: no es que estos organismos no puedan existir
 * en el sistema (podría haber una excepción legítima), es que quien da de
 * alta debe confirmarlo conscientemente en vez de crearlo de pasada.
 *
 * En shared (no solo backend) para que tanto `scripts/crear-organismo.ts`
 * (imprime la advertencia en la terminal) como el panel del operador
 * (`frontend-operador/src/PanelOperador.tsx`, la muestra mientras se
 * completa el formulario) usen la MISMA regla — antes solo vivía en el
 * script CLI y el alta vía panel la pasaba por alto en silencio.
 */
export function advertenciaConflictoInteres(comuna, region) {
    const c = comuna.trim().toLowerCase();
    const r = region.trim().toLowerCase();
    if (c === 'chillán viejo' ||
        c === 'chillan viejo' ||
        r.includes('ñuble') ||
        r.includes('nuble')) {
        return (`Conflicto de interés conocido (doc 01 §2): "${comuna}, ${region}" coincide con ` +
            'Chillán Viejo / Región de Ñuble. Confirmá que esta excepción es intencional antes de continuar.');
    }
    return undefined;
}
//# sourceMappingURL=conflicto-interes.js.map